// Canonical palette tokens from DOCS/REFERENCE/art_direction.png.
// Treat these as the source of truth — every visual change should pull
// from here, not pick its own hex. Values are eyeballed from the
// reference board and may want a small nudge under in-engine lighting.

export const palette = {
  forestGreen: '#3d5e35',
  mossTeal:    '#557060',
  sage:        '#a3b08a',
  barkBrown:   '#5a3e2a',
  warmBeige:   '#d8c4a4',
  goldenSun:   '#e8a647',
  acornOrange: '#c8742c',
  softSkyBlue: '#a3c8d8',
} as const;

// Derived scene tokens. Semantic names so scene code reads as
// "skyColor" rather than "softSkyBlue" — this is the seam to retune
// the look without renaming everywhere.
export const scene = {
  sky:               palette.softSkyBlue,
  fog:               palette.softSkyBlue,
  fogNear:           25,
  fogFar:            85,
  ambientColor:      palette.warmBeige,
  ambientIntensity:  0.55,
  directionalColor:  palette.goldenSun,
  directionalIntensity: 1.05,
  ground:            palette.forestGreen,
  trunk:             palette.barkBrown,
  // Branches are visible-only segments today (not traversable). A
  // slightly darker bark tone keeps them readable against trunks
  // without leaving the palette.
  branch:            '#4a3022',
  // Knots read as a darker bark accent against the trunk.
  knot:              '#3b2818',
  characterLocal:    palette.acornOrange,
  // Remote characters use warm beige for v1 — reads as "another
  // squirrel," not a different species. Per-character colors land
  // when the character-design board's named squirrels (Scamp gray,
  // Rusty red-brown, Tilda elder) get real entities.
  characterRemote:   palette.warmBeige,
} as const;
